export class G_ItemTypeViewModel {
    public Id: number;
    public Name: string;
}
